import { Minimize2 } from 'lucide-react';
import { mkIcon } from './utils';
export const SvgArrowsShrink3 = mkIcon(Minimize2);